import { useEffect } from "react";
import { Navbar } from "@/components/navbar";
import { HeroSection } from "@/components/landing-page-components/hero-section";
import { RoadmapSection } from "@/components/landing-page-components/roadmap-section";
import { HowElevitaWorksSection } from "@/components/landing-page-components/how-elevita-works-section";
import UnmetNeedSection from "@/components/landing-page-components/unmet-need-section";
import { SolutionSection } from "@/components/landing-page-components/solution-section";
import { ClinicalValidationSection } from "@/components/landing-page-components/clinical-validation-section";
import { JourneySection } from "@/components/landing-page-components/journey-section";
import { FounderStorySection } from "@/components/landing-page-components/founder-story-section";
import { TeamSection } from "@/components/landing-page-components/team-section";
import { VoicesSection } from "@/components/landing-page-components/voices-section";
import { PartnerCTASection } from "@/components/landing-page-components/partner-cta-section";
import { Footer } from "@/components/footer";
import { SectionDivider } from "@/components/landing-page-components/section-divider";
import { EdgeGlow } from "@/components/edge-glow";

export default function Home() {
  useEffect(() => {
    // Add custom CSS for the glowing CTA button
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes glow {
        0% { box-shadow: 0 0 5px #14b8a6, 0 0 10px #14b8a6; }
        100% { box-shadow: 0 0 10px #14b8a6, 0 0 20px #14b8a6, 0 0 30px #14b8a6; }
      }
      .cta-button {
        position: relative;
        z-index: 1;
      }
      .cta-button::after {
        content: '';
        position: absolute;
        top: -5px;
        left: -5px;
        right: -5px;
        bottom: -5px;
        border-radius: 0.5rem;
        background: transparent;
        z-index: -1;
        animation: glow 2s ease-in-out infinite alternate;
      }
      html {
        scroll-behavior: smooth;
      }
      body {
        background-color: #000000;
        overflow-x: hidden;
        position: relative;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="bg-white dark:bg-black text-black dark:text-white min-h-screen relative">
      <EdgeGlow />
      <Navbar />
      <HeroSection />
      <SectionDivider />
      <RoadmapSection />
      <SectionDivider />
      <JourneySection />
      <SectionDivider />
      <UnmetNeedSection />
      <SectionDivider />
      <SolutionSection />
      <SectionDivider />
      <ClinicalValidationSection />
      <SectionDivider />
      <HowElevitaWorksSection />
      <SectionDivider />
      <SectionDivider />
      <FounderStorySection />
      <SectionDivider />
      <TeamSection />
      <SectionDivider />
      <VoicesSection />
      <SectionDivider />
      <PartnerCTASection />
      <Footer />
    </div>
  );
}
